var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundOnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_1126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2536 1.92197C16.3926 2.00054 16.5083 2.11462 16.5889 2.25254C16.6694 2.39046 16.7119 2.54728 16.712 2.707V24.363C16.712 24.5226 16.6697 24.6794 16.5893 24.8174C16.5089 24.9553 16.3934 25.0695 16.2545 25.1482C16.1156 25.2269 15.9583 25.2674 15.7987 25.2655C15.6391 25.2635 15.4828 25.2193 15.3458 25.1372L6.53726 19.8513H3.17697C2.45903 19.8513 1.77049 19.5661 1.26283 19.0585C0.755172 18.5508 0.469971 17.8623 0.469971 17.1443L0.469971 9.92025C0.470449 9.20262 0.755861 8.51455 1.26347 8.00728C1.77108 7.50001 2.45934 7.21505 3.17697 7.21505H6.53726L15.344 1.93279C15.4811 1.8506 15.6375 1.80629 15.7973 1.80439C15.9572 1.80248 16.1146 1.84306 16.2536 1.92197ZM25.4718 7.47853L24.833 6.84149L23.5571 8.11739L24.1905 8.75263L24.1959 8.75624L24.232 8.79594C24.5036 9.12803 24.7372 9.4894 24.9286 9.87333C25.3256 10.6656 25.7353 11.8801 25.7353 13.5278C25.7353 15.1754 25.3238 16.39 24.9286 17.1822C24.7765 17.49 24.5971 17.7835 24.3926 18.0593C24.33 18.1421 24.2637 18.2222 24.1941 18.2993L24.1905 18.3047L23.5571 18.9364L24.833 20.2141L25.4718 19.577L25.4736 19.5734L25.4772 19.5698L25.4863 19.5608L25.5115 19.5355L25.5891 19.4489C25.6523 19.3767 25.7371 19.2738 25.8364 19.1421C26.0349 18.8786 26.2893 18.4924 26.542 17.9889C27.0473 16.9783 27.54 15.4876 27.54 13.5278C27.54 11.5679 27.0491 10.0791 26.542 9.06664C26.3423 8.66202 26.1067 8.27608 25.8382 7.91346C25.7357 7.77767 25.6267 7.64698 25.5115 7.52185L25.4863 7.49478L25.4772 7.48575L25.4736 7.48214C25.4736 7.48034 25.47 7.47854 24.833 8.11739L25.4718 7.47853Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_1126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.07,
    height: 27.07,
    fill: "white",
    transform: "translate(0.469971)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOnIcon);
export default __webpack_public_path__ + "static/media/sound-on-icon.6c2504082b7ee1f2f7ff4d92eef696f1.svg";
export { ForwardRef as ReactComponent };